import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    RESET_FORGOT_PASSWORD,
    resetForgotPasswordFail,
    resetForgotPasswordSuccess
} from '../action/resetForgotPasswordAction'

// api 
import resetForgotPasswordApi from '../api/resetForgotPasswordApi'

export function* resetForgotPasswordSaga(action) {
    try {
        const response = yield call(() => resetForgotPasswordApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(resetForgotPasswordSuccess(response, action))
        } else {
            yield put(resetForgotPasswordFail(response, action))
        }
    }
    catch (e) {
        yield put(resetForgotPasswordFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(RESET_FORGOT_PASSWORD, resetForgotPasswordSaga)
}
